var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClothing = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 29v-2.588l9-5V19h1a1 1 0 1 0-1-1h-2a3 3 0 1 1 4 2.829v.583l9 5V29H12Zm10-5.856L15.058 27h13.884L22 23.144Z",
  fill: "#2D2D2D",
  fillRule: "evenodd"
})));
export default SvgClothing;